export default __webpack_public_path__ + "static/media/question-circle.c9a67ed9.svg";